import { useDispatch } from 'react-redux';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import DialogActions from '@mui/material/DialogActions';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import { deleteUserAccount } from '../../reducers/AdminUserMgtReducer';
import { closeModal } from '../../reducers/modal';

const ConfirmModal = ({ styles, data }) => {
  const dispatch = useDispatch();
  const userId = data;

  const handleDeleteConfirmation = () => {
    dispatch(deleteUserAccount(userId));
  };

  const onClose = () => {
    dispatch(closeModal());
  };
  return (
    <>
      <DialogTitle id="responsive-dialog-title" style={styles.title}>Confirm the action</DialogTitle>
      <DialogContent style={styles.content}>
        <Typography>Are you sure you want to delete the user account</Typography>
      </DialogContent>
      <DialogActions style={styles.content}>
        <Button color="primary" variant="outlined" onClick={onClose}>
          Cancel
        </Button>
        <Button variant="contained" onClick={handleDeleteConfirmation}>
          Confirm
        </Button>
      </DialogActions>

    </>
  );
};
export default ConfirmModal;
